import React from "react";
import SectionHeader from "./SectionHeader";
import { formatDate, getBenefitLabel, getCurrencySymbol } from "./rveoHelpers";
import { formatNumber } from "../../../../Utils/utils";
import { getTitleCase } from "../../../../Utils/simulaciones/simulaciones";
import { RVEOSimulationData } from "../../../../interfaces/rveoSimulations";
import { typeCurrency } from "../../../../Utils/constants";

interface RVEOGeneralInfoProps {
  modalData: RVEOSimulationData;
}

const RVEOGeneralInfo: React.FC<RVEOGeneralInfoProps> = ({ modalData }) => {
  const currencyLabel =
    typeCurrency[modalData.moneda as keyof typeof typeCurrency] || "-";

  return (
    <div className="card-verify">
      <SectionHeader title="Información General" />
      <div className="card-verify__rows">
        <div>
          <div className="card-verify__quote">Nº de Solicitud</div>
          <div className="card-verify__data">
            {modalData.nroSolicitud || "-"}
          </div>
        </div>
        <div>
          <div className="card-verify__quote">CUSPP</div>
          <div className="card-verify__data">{modalData.cuspp || "-"}</div>
        </div>
        <div>
          <div className="card-verify__quote">Fecha de Cálculo</div>
          <div className="card-verify__data">
            {formatDate(modalData.fechaCalculo)}
          </div>
        </div>
      </div>
      <div className="card-verify__rows-line"></div>
      <div className="card-verify__rows">
        <div>
          <div className="card-verify__quote">Fecha de Devengue</div>
          <div className="card-verify__data">
            {formatDate(modalData.fechaDevengue)}
          </div>
        </div>
        <div>
          <div className="card-verify__quote">Capital</div>
          <div className="card-verify__data">
            {getCurrencySymbol(modalData.moneda)}
            {formatNumber.new(modalData.capital || 0)}
          </div>
        </div>
        <div>
          <div className="card-verify__quote">Moneda</div>
          <div className="card-verify__data">{modalData.monedaModalidad || currencyLabel}</div>
        </div>
      </div>
      <div className="card-verify__rows-line"></div>
      <div className="card-verify__rows">
        <div>
          <div className="card-verify__quote">Prestación</div>
          <div className="card-verify__data">
            {getBenefitLabel(modalData.prestacion)}
          </div>
        </div>
        <div>
          <div className="card-verify__quote">Tipo de Cotización</div>
          <div className="card-verify__data">
            {getTitleCase(modalData.tipoCotizacion || "-")}
          </div>
        </div>
        <div>
          <div className="card-verify__quote">Gratificación</div>
          <div className="card-verify__data">
            {modalData.gratificacion === "S" ? "Sí" : "No"}
          </div>
        </div>
      </div>
      <div className="card-verify__rows-line"></div>
      <div className="card-verify__rows">
        <div>
          <div className="card-verify__quote">Tipo de Cambio</div>
          <div className="card-verify__data">
            {modalData.tipoCambio || "-"}
          </div>
        </div>
        <div>
          <div className="card-verify__quote">AFP Tasa</div>
          <div className="card-verify__data">{modalData.afpTasa || "-"}</div>
        </div>
        <div>
          <div className="card-verify__quote">Renta Promedio</div>
          <div className="card-verify__data">{modalData.remProm || "-"}</div>
        </div>
      </div>
    </div>
  );
};

export default RVEOGeneralInfo;
